<template>
  <div class="text-left">
    <b-list-group>
      <b-list-group-item :key="upload.id" v-for="upload in uploads">
        <div class="d-flex">
          <div class="pr-3 my-auto">
            <b-button v-if="upload.active" class="text-danger px-0" variant="link" size="small"
                      @click="$emit('cancel', upload)">
              <font-awesome-icon icon="fa-solid fa-stop" />
            </b-button>
            <font-awesome-icon v-else-if="upload.success" icon="fa-solid fa-check-circle" size="lg" class="text-success"/>
            <font-awesome-icon v-else-if="upload.error" icon="fa-solid fa-exclamation-triangle" size="lg" class="text-danger"/>
          </div>

          <div class="flex-fill">
            <div class="mb-2">{{ upload.name }}</div>
            <div class="d-flex">
              <div class="flex-fill my-auto">
                <b-progress show-progress show-value :max="100">
                  <b-progress-bar :value="Math.round(upload.progress)"/>
                </b-progress>
              </div>
              <div class="my-auto ml-auto pl-3">
                {{ upload.speed | prettyBytes(2) }}/s
              </div>
            </div>
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
    <div class="my-3 text-center">
      <div class="font-italic mt-2">Do NOT refresh or close window during upload.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "files-upload-list",
  props: {
    uploads: Array
  }
}
</script>

<style scoped>

</style>